import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stockSentimentsPanel"},[(_vm.sentimentsLoaded)?_c('div',{staticClass:"sentimentChart"},[_c('apexchart',{ref:"stockChart",staticClass:"stockChart",attrs:{"width":"100%","type":"bubble","options":_vm.chartOptions,"series":_vm.series}})],1):_c(VSkeletonLoader,{attrs:{"type":"image"}}),_c('div',{staticClass:"sentimentDetails",domProps:{"innerHTML":_vm._s(_vm.sentimentDetails)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }